<template>

    <!-- Table row -->
    <tr :class="Pogodba?.IsAnonymized ? 'tr--anonymized' : null">
 
        <!-- Sporočila -->
        <td class="td-center td--message">
            <v-badge v-if="Pogodba!.StKomentarjev != 0 && !Pogodba!.IsAnonymized" :content="Pogodba!.StKomentarjev"
                class="badge--primary" @click="$emit('change', Pogodba!.PogodbaId)">
                <img src="@assets/images/contract-list/icon-message-default.svg" alt="Message"
                    class="">
            </v-badge>

            <img v-else-if="Pogodba!.VsehKomentarjev != 0" src="@assets/images/contract-list/icon-message-default.svg" alt="Message"
                class="">
        </td>

        <!-- Pogodba -->
        <td>
            <div class="td--pogodba mb-1" @click="$emit('change', Pogodba!.PogodbaId)" >{{ Pogodba!.StPogodbe }}</div>
            <div class="td--sm">{{ getDateCorrectedFormat(Pogodba!.Vneseno) }}, {{ getTimeCorrectedFormat(Pogodba!.Vneseno) }}</div>
        </td>

        <!-- Status -->
        <td class="td--status">
            <v-tooltip 
                location="right" 
                class="tooltip--pogodba-status"
            >
                <template v-slot:activator="{ props }">
                    <span v-bind="props">
                        <span class="tag " :class="'tag--' + PogodbaStatus[Pogodba!.StatusPogodbe]">
                            {{ i18n.global.t("ContractStatus." + PogodbaStatus[Pogodba!.StatusPogodbe]) }}
                            <div class="loader-dots loader-dots-status" v-if="PogodbaStatus[Pogodba!.StatusPogodbe] == 'VOdobravanju'"></div>
                        </span>
                    </span>
                </template>
                <template v-if="PogodbaStatus[Pogodba!.StatusPogodbe] == 'VOdobravanju'">
                    <div class="tooltip__title">V odobravanju</div>
                    <div>
                        Pogodbo pregledujemo pri NLB Buy&amp;Go. Vso komunikacijo o morebitni manjkajoči ali nepopolni dokumentaciji vodimo direktno s stranko. 
                        <div class="notification notification--info notification--compact">
                            Blago lahko stranki izdate, ko se bo status pogodbe spremenil v Odobreno.
                        </div>
                    </div>
                </template>
                <template v-else>
                    <span>
                        {{ i18n.global.t('TooltipMessage.' + PogodbaStatus[Pogodba!.StatusPogodbe]) }}
                    </span>
                </template>
            </v-tooltip>
        </td>

        <!-- Vrednost -->
        <td class="d-none d-md-block">
            <div class="mb-1">{{ $n(Pogodba!.Vrednost, 'decimal' )}} EUR</div>
            <div class="td--sm">{{ Pogodba!.Rocnost + ' obrokov' }}</div>
        </td>

        <!-- Produkt -->
        <td class="d-none d-md-block">
            <div class="mb-1">{{ i18n.global.t("ProductName." + Pogodba!.Produkt) }}</div>
            <div class="td--sm">{{ i18n.global.t("ProductType." + Pogodba!.ProduktTip) }}</div>
        </td>

        <!-- Stranka -->
        <td>
            <div class="mb-1">{{ Pogodba!.Stranka }}</div>
            <!-- <div class="td--sm">{{ 'DŠ: ' + Pogodba!.DavcnaSt }}</div> -->
        </td>

        <!-- Poslovalnica -->
        <td class="d-none d-md-block">
            <div class="mb-1">{{ Pogodba!.Poslovalnica }}</div>
            <!-- <div class="td--sm">{{ 'Podpisano: ' + i18n.global.t("SignType." + Pogodba!.SignType) }}</div> -->
            <div class="td--sm">{{ Pogodba!.StRacuna ? 'Št. dokumenta: ' + Pogodba!.StRacuna : '' }}</div>
        </td>

        <!-- Vnesel -->
        <td class="d-none d-md-block">
            {{ Pogodba!.Vnesel.split(' ').map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()).join(' ') }}
        </td>

        <!-- Action btns -->
        <td class="td-center d-none d-sm-flex justify-end ga-2 align-center">
            <v-btn
                v-if="PogodbaStatus[Pogodba!.StatusPogodbe] == 'NezakljucenPodpis' || Pogodba!.ShowCompleteContract"
                flat size="small" class="btn btn--sm btn--primary-fill" @click="PogodbaButtonClick()">
                {{
                    PogodbaStatus[Pogodba!.StatusPogodbe] == 'NezakljucenPodpis' ? "Podpiši" : (Pogodba?.IsIdentified) ? "Preveri SISBON" : "Identificiraj" }}
            </v-btn>
            <v-btn
                v-if="appStore.User.PartnerId == 1153 && Pogodba!.StatusPogodbe == PogodbaStatus.Odobreno"
                flat size="small" class="btn btn--sm btn--primary-fill" @click="ShowIkeaPDF()">
                    Prikaži potrdilo
            </v-btn>
            <!-- <v-btn size="small" @click="$emit('change', Pogodba!.PogodbaId)"
                flat class="btn btn-default px-0">
                <img src="@assets/images/contract-list/icon-arrow-sm-right.svg" alt="Open" class="">
            </v-btn> -->
            <div>

                <v-menu :disabled="Pogodba!.StatusPogodbe == 140 || Pogodba!.StatusPogodbe == 170 || Pogodba!.StatusPogodbe == 160">

                    <template v-slot:activator="{ props }">
                        <div v-bind="props">

                            <!-- More btn -->
                            <v-btn :disabled="Pogodba!.StatusPogodbe == 140 || Pogodba!.StatusPogodbe == 170 || Pogodba!.StatusPogodbe == 160" class="btn btn--default-fill btn--round btn--sm ml-auto">
                                <img src="@assets/images/contract-list/icon-more.svg" alt="Več">
                            </v-btn>

                        </div>
                    </template>

                    <v-list>

                        <!-- Download contract -->
                        <v-list-item title="Storniraj" @click="emit('cancel-contract')">
                        </v-list-item>

                    </v-list>

                </v-menu>

            </div>
        </td>

    </tr>

</template>

<script setup lang="ts">
    import { PropType, Ref, ref } from "vue";
    import { IPogodba, PogodbaStatus } from "@/app/store/app/contract-list/store";
    import { getDateCorrectedFormat, getTimeCorrectedFormat } from "@/app/utils/date-functions";
    import { i18n } from "@app/i18n";
    import { useDokoncanjePogodbeStore } from "@/app/store/app/contract-completion/store";
    import { useSeznamPogodbStore } from "@/app/store/app/contract-list/store";
    import { useAppStore } from "@/app/store/app/store";
    import { useFw4Store } from "fw4-library";

    const emit = defineEmits(['change', 'cancel-contract']);

    const props = defineProps({
        Pogodba: Object as PropType<IPogodba>
    });

    const appStore = useAppStore();
    const fw4Store = useFw4Store();
    const dokoncanjePogodbeStore = useDokoncanjePogodbeStore();
    const seznamPogodbStore = useSeznamPogodbStore();
    dokoncanjePogodbeStore.$reset();

    function ShowIkeaPDF(){
        fw4Store.ShowReport(
            {
                Title: "Izpis IKEA",
                MethodName: "IKEAConfirmContract",
                Parameters: { "PogodbaId": props.Pogodba!.PogodbaId },
                FileName: "IKEA_" + props.Pogodba!.PogodbaId.toString()
            });
    }

    function PogodbaButtonClick() {
        switch (PogodbaStatus[props.Pogodba!.StatusPogodbe]) {
            case "VOdobravanju":
            case "Odobreno":
            case "PotrebnaIdentifikacija":
                dokoncanjePogodbeStore.getPogodba(props.Pogodba!.PogodbaId);
                break;
            case "NezakljucenPodpis":
                seznamPogodbStore.PogodbaDetails.PogodbaId = props.Pogodba!.PogodbaId;
                seznamPogodbStore.pogodbaPodpisLater("seznam");
                break;
        }
        //router.push({name: "dokoncanje_pogodba", params:{ id: props.Pogodba!.PogodbaId }})
    };

</script>
<style scoped>

</style>